module.exports = __webpack_public_path__ + "img/florent-pagny.b0bab357.jpg";